var map = {
	"./applab/skins": 2461,
	"./bounce/skins": 2866,
	"./craft/agent/skins": 2870,
	"./craft/code-connection/skins": 2871,
	"./craft/designer/skins": 2869,
	"./craft/simple/skins": 2868,
	"./flappy/skins": 2873,
	"./jigsaw/skins": 2886,
	"./maze/skins": 1863,
	"./netsim/skins": 2906,
	"./p5lab/skins": 2266,
	"./studio/skins": 2908,
	"./studio/starwars/skins": 2514,
	"./turtle/skins": 2552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4297;